import axios from 'axios';

const axiosInstance = axios.create({
    withCredentials: true,
    timeout: 15000,
    headers: {
        // 'Application-Type': 'application/json',
        // 'Access-Control-Allow-Credentials': true,
        // 'Access-Control-Allow-Origin': 'http://localhost:3000',
        // 'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Accept': 'application/json',
        'X-TRP-Requested-With': 'XMLHttpRequest'
    }
});

export default axiosInstance;
